// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_FECTCH_LOGIN_OUT,
} from './constants';

export function fectchLoginOut() {
  return {
    type: COMMON_FECTCH_LOGIN_OUT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_FECTCH_LOGIN_OUT:
      localStorage.clear()
      return {
        ...state,
        studentBasics: {},
        fetchLoginByPhoneSuccess: null,
        fetchLoginSuccess: {}
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/fectchLoginOut.js